<template>
  <div>
    <button
      :class="[tag.selected == true ? 'font-bold' : 'font-normal', 'text-base']" 
      @click="toggle(tagId)"
    >
      <span
        v-if="tagId.includes('Face')"
        class="face"
        :class="tagId.toLowerCase().replaceAll(' ', '-')"
      />
      {{ tagId }}
    </button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import useFilterToggleTag from '../composables/useFilterToggleTag'
const { mapGetters } = createNamespacedHelpers('collection')

export default {
  props: { tagId: { type: String, required: true } },
  emits: ['tagselected'],
  setup(props, ctx) {
    const { toggleTag } = useFilterToggleTag()
    const toggle = function () {
      toggleTag(props.tagId)
      ctx.emit('tagselected')
    }
    return { toggle }
  },
  computed: {
    ...mapGetters(['getTag']),
    tag: function () {
      return this.getTag(this.tagId)
    },
  },
}
</script>

<style scoped>
.face {
  height: 18px;
  width: 24px;
  position: relative;
  top: 4px;
}
</style>
